module.exports = __webpack_public_path__ + "static/media/firewall.f0652a2e.png";